import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import useHttp from "../../../../../hooks/useHttp";

import { hideModal } from "../../../../../store/slices/modal";
import { DISPUTES_OTHER_PARTY_RESPONSE_URL } from "../../../../../utils/api-ends";
import LoaderImg from "../../../../../assets/media/loader.gif";
import store from "../../../../../store";
import { singleDisputObjValue } from "../../../../../store/slices/Dispute";

const OtherPartyDisagree = ({ modalData }) => {
  const dispatch = useDispatch();
  const closeModal = () => dispatch(hideModal());
  const { error, isLoading, sendRequests } = useHttp();
  const [withdrawError, setWithdrawError] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const [withdrawReason, setWithdrawReason] = useState("");
  const disputeData = useSelector((state) => state.Dispute);

  const onChangeWithdrawReason = (e) => {
    setWithdrawReason(e.target.value);
  };

  const confirmWithdraw = (e) => {
    // Clear messages
    setSuccessMessage("");
    setWithdrawError([]);

    const formData = new FormData();
    formData.append("status", "disagree");
    formData.append("reason", withdrawReason);

    const response = (data) => {
      setSuccessMessage(data.message);
      setWithdrawError([]);
      setTimeout(function () {
        closeModal();
      }, 3000);
      store.dispatch(
        singleDisputObjValue({
          singleDisputObj: data.dispute_obj,
        })
      );
    };

    // Send request to Cancel withdraw request
    sendRequests(
      {
        url: DISPUTES_OTHER_PARTY_RESPONSE_URL(disputeData.singleDisputObj?.id),
        method: "POST",
        data: formData,
      },
      response
    );
  };

  // Manipulates server errors
  useEffect(() => {
    if (error) {
      if (error.reason) {
        setWithdrawError(error.reason);
      }
      if (error.general) {
        setWithdrawError(error.general);
      }
    }
  }, [error]);

  return (
    <div className="col-xl-6 col-lg-8 col-md-10">
      <div className="load-add-edit-modal">
        {withdrawError?.map((value, index) => (
          <p className="auth-error withdraw-message-style">{value}</p>
        ))}
        <p className="auth-instruction SuccessMessage_SuccessMsg__fTMdE withdrawAmount-success-message withdraw-message-style">
          {successMessage}
        </p>

        <div className="input-box-area" single-labe="true">
          <label> Disagree Reason</label>
          <textarea
            placeholder="Disagree Reason"
            name="address"
            spellcheck="false"
            onChange={onChangeWithdrawReason}
          ></textarea>
        </div>

        <div className="multiple-btn modal-button ">
          <button
            data-id={disputeData.singleDisputObj?.id}
            onClick={confirmWithdraw}
          >
            {isLoading && (
              <img src={LoaderImg} alt="" style={{ width: "20px" }} />
            )}
            Confirm
          </button>
          <button onClick={closeModal}> Cancel </button>
        </div>
      </div>
    </div>
  );
};

export default OtherPartyDisagree;
